import { FC, useEffect, useState } from "react";
import { PulseLoader } from "react-spinners";
import { Line } from "rc-progress";
import { randomIntFromInterval } from "utils/random";
import { colourScheme } from "utils/styling/colours";
import { Text } from "utils/styling/typography.styled";
import * as Styled from "./Loader.styled";
type LoaderProps = {
  prompts: string[];
};
export const Loader: FC<LoaderProps> = ({
  prompts
}) => {
  const [percent, setPercent] = useState<number>(0);
  const [prompt, setPrompt] = useState<string>("");
  useEffect(() => {
    setPrompt(prompts[randomIntFromInterval(0, prompts.length - 1)]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    const timer = setTimeout(() => {
      setPercent(percent => Math.min(percent + randomIntFromInterval(3, 1), 96));
    }, randomIntFromInterval(1000, 1350));
    return () => clearTimeout(timer);
  }, [percent, setPercent]);
  return <Styled.LoaderTextWrapper data-sentry-element="unknown" data-sentry-component="Loader" data-sentry-source-file="index.tsx">
            <Styled.LoaderContainer data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                <PulseLoader color={colourScheme.white} size={16} data-sentry-element="PulseLoader" data-sentry-source-file="index.tsx" />
            </Styled.LoaderContainer>
            <Text data-sentry-element="Text" data-sentry-source-file="index.tsx">{prompt}</Text>
            <Line strokeWidth={1} strokeColor={colourScheme.success} trailColor={colourScheme.primaryLight} percent={percent} data-sentry-element="Line" data-sentry-source-file="index.tsx" />
        </Styled.LoaderTextWrapper>;
};